export { default } from "./AdministrationPage";
